module.exports = __webpack_public_path__ + "img/3.96fcbb4e.jpg";